import React from 'react';
import { useI18n } from '@/contexts/I18nContext';

interface CardItem {
  label: string;
  onSeeAll: () => void;
}

interface HorizontalCardSliderProps {
  items: CardItem[];
}

export const HorizontalCardSlider: React.FC<HorizontalCardSliderProps> = ({ items }) => {
  const { t } = useI18n();
  
  return (
    <div className="overflow-x-auto pb-2 scrollbar-hide">
      <div className="flex space-x-4 min-w-full">
        {items.map((item, idx) => (
          <div
            key={item.label}
            className="flex flex-col items-center justify-center min-w-[180px] w-44 h-32 bg-white/5 rounded-2xl px-4 py-4 mr-2 last:mr-0"
          >
            <span className="text-white font-semibold text-base font-roboto mb-4 text-center w-full truncate">
              {item.label}
            </span>
            <button
              onClick={item.onSeeAll}
              className="bg-[#D72E16] text-white font-roboto text-xs rounded-full px-6 py-2 font-semibold focus:outline-none focus:ring-2 focus:ring-[#D72E16] focus:ring-offset-2 transition-all"
            >
              {t('calendar.see_all')}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}; 